var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CrmSpaStaleUpdateBanner',{attrs:{"value":_vm.stale},on:{"snooze":_vm.snooze}})
}
var staticRenderFns = []

export { render, staticRenderFns }